import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Pencil02 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "pencil02",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "m18 2 4 4M2 22l1.2764-4.6801c.0833-.3054.125-.458.1888-.6004a2.001 2.001 0 0 1 .2081-.3586c.092-.1261.2038-.238.4276-.4618L14.4343 5.5657c.198-.198.297-.297.4112-.3341a.5.5 0 0 1 .309 0c.1142.037.2132.136.4112.334l2.8686 2.8687c.198.198.297.297.3341.4112a.499.499 0 0 1 0 .309c-.0371.1142-.1361.2132-.3341.4112L8.1009 19.899c-.2238.2238-.3357.3357-.4618.4276a2.0028 2.0028 0 0 1-.3586.2081c-.1423.0639-.295.1055-.6004.1888L2 22Z"
    })
  }));
};
export default Pencil02;